import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { View } from "@/components/ui";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Drawer, DrawerContent, DrawerOverlay } from "@/components/ui/drawer";
import { cn } from "@/lib/utils";

import type { BottomDrawerModalProps } from "./type";

export function BottomDrawerModalAnimated({
  open,
  onOpenChange,
  children,
  title,
  footer,
  className,
}: BottomDrawerModalProps) {
  const { mediaQuery } = useWindowDimensions();

  // its weird because the drawer onOpenChange is triggered twice
  // then causing the drawer open state is always false if we don't do this handler to prevent double invocation
  const handleOpenChange = (isOpen: boolean) => {
    if (open !== isOpen) {
      onOpenChange?.(isOpen);
    }
  };

  if (mediaQuery === "desktop") {
    return (
      <Dialog open={open} onOpenChange={handleOpenChange}>
        <DialogContent className="flex max-h-[90dvh] flex-col gap-0 rounded-2xl bg-white p-0 sm:rounded-2xl">
          {title && <View className="shrink-0 px-4 pb-4 pt-4">{title}</View>}
          <View className={cn("min-h-0 w-full flex-1 overflow-auto px-4", className)}>
            <View className="flex flex-col gap-0">{children}</View>
          </View>
          {footer && <View className="shrink-0 px-4 pb-4 pt-4">{footer}</View>}
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer open={open} onOpenChange={handleOpenChange} direction="bottom">
      <DrawerContent
        className={cn("flex flex-col", className)}
        overlay={
          <DrawerOverlay
            onClick={(e) => {
              e.stopPropagation();
              handleOpenChange(false);
            }}
          />
        }
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {title && <View className="px-4 pb-4 pt-4">{title}</View>}
        <View className={cn("flex-1 overflow-auto px-4", className)}>
          <View className="flex flex-col gap-0">{children}</View>
        </View>
        {footer && <View className="px-4 pb-4 pt-4">{footer}</View>}
      </DrawerContent>
    </Drawer>
  );
}
